import type { FilterData } from '../../FilterData';

export function mergeLocalFilters(defaultFilters: FilterData[], newFilters: FilterData[]) {
  const filterMap: Record<string, FilterData> = {};

  defaultFilters.forEach((filter) => {
    filterMap[filter.type] = filter;
  });

  newFilters.forEach((filter) => {
    filterMap[filter.type] = filter;
  });

  return Object.values(filterMap);
}
